<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<b-modal id="confirm-delete-modal" title="Confirm delete" okTitle="Yes, delete" @ok.prevent="deleteNodes" @hidden="reset" ok-variant="danger">
  <p>Do you really want to delete the following nodes?</p>
  <p>
  <ul>
    <li v-for="node in nodesToDelete" :key="node">{{node}}</li>
  </ul>
  </p>
  <div v-if="selectedUndeletableNodes.length > 0">
    <p><strong>Warning</strong>: following selected nodes can't be deleted and will be ignored:</p>
    <p>
    <ul>
      <li v-for="node in selectedUndeletableNodes" :key="node">{{node}}</li>
    </ul>
    </p>
  </div>
</b-modal>
</template>

<script>
export default {
  name: 'ConfirmDeleteModal',
  computed: {
    nodesToDelete() { return this.$store.state.nodesToDelete },
    selectedUndeletableNodes() { return this.$store.state.selectedUndeletableNodes }
  },
  methods: {
    reset() {
      this.$store.commit('setNodesToDelete', []);
    },
    deleteNodes() {
      this.$store.dispatch('deleteNodes')
        .then(() => {
          this.$bvModal.hide('confirm-delete-modal');
        });
    }
  }
}
</script>
